import { Dispatch, SetStateAction } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { TestResultForm } from "../../types"

type TestField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const TestField = (props: TestField) => {
  const { formData, setFormData } = props

  const options = [
    'In-Office Test Result',
    'In-Office Retest Result'
  ]

  const handleChange = (event: SelectChangeEvent<number>) => {
    const nextForm = structuredClone(formData)

    const value = Number(event.target.value)
    const isRetest = Boolean(value)

    nextForm.retest = isRetest

    setFormData(nextForm)
  }

  const label = 'Test/Retest *'
  const value = formData.retest === null ? ''  : Number(formData.retest)
  const placeholder = 'Select a Type'


  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ width: '100%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select<number> 
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            options.map((option, index) => {
              return (
                <MenuItem key={index} value={index}>
                  { option }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default TestField
